import React from 'react';
import { AppHeader } from './AppHeader';
export const AppLayout = (props) => {
    const { children } = props;
    return (React.createElement("div", { className: "app-layout" },
        React.createElement(AppHeader, null),
        React.createElement("main", { className: "w-screen h-screen overflow-hidden pt-16", id: "content" }, children)));
};
